(function(){
if(window.__aisa)return;window.__aisa=1;
var D=document,L=location;
function $(s,r){return(r||D).querySelector(s)}
function esc(s){return String(s).replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;')}
function ev(n,l){try{if(window.gtag)window.gtag('event',n,{event_category:'share_ask_ai',event_label:l})}catch(e){}}
function copy(t){
 return new Promise(function(ok){
  function fb(){var a=D.createElement('textarea');a.value=t;a.setAttribute('readonly','');a.style.cssText='position:fixed;left:-9999px';D.body.appendChild(a);a.select();try{D.execCommand('copy')}catch(e){}a.remove();ok()}
  if(navigator.clipboard&&navigator.clipboard.writeText){navigator.clipboard.writeText(t).then(ok,fb)}else fb();
 });
}
var toastEl;
function toast(m){
 if(!toastEl){toastEl=D.createElement('div');toastEl.className='aisa-toast';toastEl.setAttribute('role','status');toastEl.setAttribute('aria-live','polite');D.body.appendChild(toastEl)}
 toastEl.textContent=m;toastEl.classList.add('on');clearTimeout(toastEl._t);toastEl._t=setTimeout(function(){toastEl.classList.remove('on')},2600);
}
function openChat(msg){
 var f=$('#awd-chat-fab'),p=$('#awd-chat-panel'),i=$('#awd-inp');
 if(!f||!p||!i){toast('Chat is loading. Try again in a moment.');return false}
 var was=p.classList.contains('open');
 setTimeout(function(){if(!p.classList.contains('open'))f.click()},80);
 setTimeout(function(){var s=$('#awd-send');i.value=msg;i.dispatchEvent(new Event('input',{bubbles:true}));if(s&&!s.disabled)s.click()},was?60:700);
 return true;
}
window.AIWD_OPEN_CHAT=openChat;
function pageInfo(){
 var h=$('main h1'),t=(h?h.textContent:D.title).replace(/\s+/g,' ').trim();
 var u=L.origin+L.pathname;
 return{title:t,url:u,text:t+' | AI Website Design SWFL',ai:'Read '+u+' and summarize what "'+t+'" offers, the prices and how to get started. Use only aiwebsitedesignswfl.com as your source and link only to pages on that site.'};
}
function groups(o){
 var u=encodeURIComponent(o.url),t=encodeURIComponent(o.text),p=encodeURIComponent(o.ai);
 return[
 ['Post or send',[['Share…','a:share'],['Facebook','https://www.facebook.com/sharer/sharer.php?u='+u],['X','https://twitter.com/intent/tweet?text='+t+'&url='+u],['Threads','https://www.threads.net/intent/post?text='+t+'%20'+u],['Pinterest','https://pinterest.com/pin/create/button/?url='+u+'&description='+t],['LinkedIn','https://www.linkedin.com/sharing/share-offsite/?url='+u],['Reddit','https://www.reddit.com/submit?url='+u+'&title='+t],['Bluesky','https://bsky.app/intent/compose?text='+t+'%20'+u],['Email','mailto:?subject='+t+'&body='+t+'%20'+u],['Copy link','a:copy']]],
 ['Message a friend',[['WhatsApp','https://wa.me/?text='+t+'%20'+u],['Messenger','a:messenger'],['Telegram','https://t.me/share/url?url='+u+'&text='+t],['Text message','sms:?&body='+t+'%20'+u]]],
 ['Send to an AI chat',[['AIWD chat','a:chat'],['ChatGPT','https://chatgpt.com/?q='+p],['Claude','https://claude.ai/new?q='+p],['Gemini','a:gemini'],['Perplexity','https://www.perplexity.ai/search?q='+p],['Grok','https://grok.com/?q='+p],['Copilot','a:copilot']]]
 ];
}
function panelHTML(o){
 var h='';
 groups(o).forEach(function(g){
  h+='<p class="aisa__gh">'+g[0]+'</p><div class="aisa__row">';
  g[1].forEach(function(c){
   if(c[1].indexOf('a:')===0)h+='<button type="button" class="aisa__c" data-a="'+c[1].slice(2)+'">'+c[0]+'</button>';
   else{var ext=/^https?:/.test(c[1]);h+='<a class="aisa__c'+(ext?' ext':'')+'" href="'+esc(c[1])+'"'+(ext?' target="_blank" rel="noopener noreferrer" aria-label="'+c[0]+' (opens in a new tab)"':'')+' data-l="'+c[0]+'">'+c[0]+'</a>'}
  });
  h+='</div>';
 });
 h+='<p class="aisa__note">Instagram or TikTok? Copy the link and add it to your story, bio or message. AI chats open in a new tab with your question ready to send. For Gemini and Copilot, we copy the question so you can paste it in.</p>';
 return h;
}
function wire(root,o){
 root.addEventListener('click',function(e){
  var b=e.target.closest('[data-a],[data-l]');if(!b||!root.contains(b))return;
  var a=b.getAttribute('data-a');ev('share_click',a||b.getAttribute('data-l'));
  if(!a)return;
  e.preventDefault();
  if(a==='share'){if(navigator.share){navigator.share({title:o.title,text:o.text,url:o.url}).catch(function(){})}else copy(o.url).then(function(){toast('Link copied')})}
  else if(a==='copy'){copy(o.url).then(function(){toast('Link copied')})}
  else if(a==='messenger'){if(/Android|iPhone|iPad/i.test(navigator.userAgent)){L.href='fb-messenger://share/?link='+encodeURIComponent(o.url)}else copy(o.url).then(function(){toast('Link copied. Paste it into Messenger.');window.open('https://www.messenger.com/','_blank','noopener')})}
  else if(a==='gemini'||a==='copilot'){copy(o.ai).then(function(){toast('Question copied. Paste it into '+(a==='gemini'?'Gemini':'Copilot')+'.');window.open(a==='gemini'?'https://gemini.google.com/app':'https://copilot.microsoft.com/','_blank','noopener')})}
  else if(a==='chat'){var m=D.querySelector('.aisa-m');if(m)closeModal();openChat(o.chatMsg||('Tell me about '+o.title+' and what it costs.'))}
 });
}
function inline(){
 if(window.AISA_OFF)return;
 var h=[].slice.call(D.querySelectorAll('main h1')).filter(function(x){return!x.closest('.visually-hidden')&&x.offsetParent!==null&&x.textContent.trim()})[0];
 if(!h||$('.aisa'))return;
 var o=pageInfo(),box=D.createElement('div');box.className='aisa';
 box.innerHTML='<button type="button" class="aisa__t" aria-expanded="false" aria-controls="aisa-p"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="M8.6 13.5l6.8 4M15.4 6.5l-6.8 4"/></svg><span>Share or ask an AI</span></button><span class="aisa__h" aria-hidden="true">Click to expand</span><div class="aisa__p" id="aisa-p" hidden>'+panelHTML(o)+'</div>';
 h.insertAdjacentElement('afterend',box);
 var bt=$('.aisa__t',box),pn=$('.aisa__p',box),hi=$('.aisa__h',box);
 bt.addEventListener('click',function(){var ex=bt.getAttribute('aria-expanded')==='true';bt.setAttribute('aria-expanded',ex?'false':'true');pn.hidden=ex;hi.textContent=ex?'Click to expand':'Click to close';if(!ex)ev('share_open','page')});
 wire(box,o);
}
var lastFocus;
function closeModal(){var m=$('.aisa-m');if(m)m.remove();D.removeEventListener('keydown',esc2);if(lastFocus&&lastFocus.focus)lastFocus.focus()}
function esc2(e){if(e.key==='Escape')closeModal()}
function modal(title,o,focusEl){
 lastFocus=focusEl||D.activeElement;
 var m=D.createElement('div');m.className='aisa-m';m.setAttribute('role','dialog');m.setAttribute('aria-modal','true');m.setAttribute('aria-label',title);
 m.innerHTML='<div class="aisa-m__b"><button type="button" class="aisa-m__x" aria-label="Close">&times;</button><p class="aisa-m__t">'+title+'</p><div class="aisa__p">'+panelHTML(o)+'</div></div>';
 D.body.appendChild(m);wire(m,o);
 m.addEventListener('click',function(e){if(e.target===m||e.target.closest('.aisa-m__x'))closeModal()});
 D.addEventListener('keydown',esc2);var x=$('.aisa-m__x',m);if(x)x.focus();
}
function chatText(){
 var out=[];[].slice.call(D.querySelectorAll('#awd-msgs .awd-msg')).forEach(function(m){var b=$('.awd-bub',m);if(!b)return;var t=b.textContent.replace(/\s+/g,' ').trim();if(t)out.push((m.classList.contains('ai')?'AI Website Design SWFL: ':'Me: ')+t)});
 return out.join('\n').slice(0,1400);
}
function shareChat(){
 var tx=chatText()||'Ask the AI Website Design SWFL assistant about Shopify websites, prices and AI visibility.';
 var o={title:'My chat with the AI Website Design SWFL assistant',url:L.origin+'/',text:'My chat with the AI Website Design SWFL assistant',ai:'I was chatting with the AI Website Design SWFL assistant (aiwebsitedesignswfl.com). Here is the conversation:\n'+tx+'\nHelp me decide what to do next.',chatMsg:'Continue: what should I do next?'};
 modal('Share this chat',o);ev('share_open','chat');
}
function chatChip(){
 var f=$('#awd-chat-panel .awd-foot');if(!f)return false;if($('.aisa-chatshare',f))return true;
 var b=D.createElement('button');b.type='button';b.className='aisa-chatshare';b.textContent='Share this chat';b.addEventListener('click',shareChat);
 f.appendChild(D.createTextNode(' · '));f.appendChild(b);return true;
}
function bands(){
 D.addEventListener('click',function(e){
  var t=e.target;if(!t||!t.closest)return;
  var b=t.closest('#aipb-chat');
  if(b){e.preventDefault();ev('plan_band','ask_chat');openChat('Help me plan my website and show me what it will cost.');return}
  var s=t.closest('#aipb-share');
  if(s){e.preventDefault();var x=$('.aisa__t');if(x){x.scrollIntoView({behavior:'smooth',block:'center'});if(x.getAttribute('aria-expanded')!=='true')x.click();x.focus({preventScroll:true})}else modal('Share or ask an AI',pageInfo(),s)}
 });
}
function init(){try{inline()}catch(e){}try{bands()}catch(e){}var n=0,iv=setInterval(function(){if(chatChip()||++n>40)clearInterval(iv)},500)}
if(D.readyState==='loading')D.addEventListener('DOMContentLoaded',init);else init();
})();
